import React from 'react';
import avatar from '../../images/team/filip-mojicevic.png'
import quote from '../../images/icon/quote.png'

const CEOQuote = () => {
    return (
        <div className="col-xl-3">
            <div className="autpr_box">
                <div className="site_author">
                    <div className="author_box">
                        <div className="author_image bg-light">
                            <img src={avatar} alt="Filip Mojicevic" />
                        </div>
                        <div className="author_box_content">
                            <h3 className="author_name text-white">Filip Mojicevic</h3>
                            <span className="author_designation text-white">CEO At ISL-Tech</span>
                        </div>
                    </div>
                    <p className="mb-0 text-white">
                        “As CEO, I’ve focused on clarity, efficiency, and results—ensuring clients get the best solutions without reinventing the wheel.”
                    </p>
                    <div className="author_box_quote">
                        <img src={quote} alt="Quote Icon" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CEOQuote;
